import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router, Routes, Route, useLocation, useParams } from 'react-router-dom';
import withLoading from './components/Loading/loading';
import TicTacToe from './components/pages/Tic-Tac-Toe';
import Home from './components/pages/Home';
import About from './components/pages/AboutPage';
import ColoringOptions from './components/pages/ColoringOptions';
import ColoringBook from './components/pages/ColoringBook';
import TRiviaHome from './components/pages/TriviaHome';
import CrossWord from './components/pages/CrossWord';
import CrossWordTwo from './components/pages/Crossword2';
import CrossWordThree from './components/pages/Crossword3';
import Games from './components/pages/Games';
import ArticlesPage from './components/pages/ArticlesPage';
import ActivitiesPage from './components/pages/ActivitiesPage';
import ScavengerHunt from './components/pages/ScavengerHunt';

import EchoesOfHarmony from './components/pages/EchoesOfHarmony';
import RiseOfShowChoir from './components/pages/RiseOfShowChoir';




import HarmonyAndHearts from './components/pages/HarmonyAndHearts';
import InYourSeat from './components/pages/InYourSeat';
import ShowChoirContests from './components/pages/ShowChoirContests';
import ExcellenceAndSuccess from './components/pages/ExcellenceAndSuccess';
import Broadway from './components/pages/Broadway';
import Showdown from './components/pages/Showdown';
import Hearts from './components/pages/Hearts';
import Moves from './components/pages/Moves';
import Recipes from './components/pages/Recipes';
import Celebrities from './components/pages/Celebrities';

import Header from './components/Header';
import Footer from './components/Footer';
import LifeAfter from './components/pages/LifeAfter';
import CollegeConnection from './components/pages/CollegeConnection';
import Outfits from './components/pages/Outfits';

const OutfitsWL = withLoading(Outfits);
const HarmonyAndHeartsWL = withLoading(HarmonyAndHearts);
const InYourSeatWL = withLoading(InYourSeat);
const ShowChoirContestsWL = withLoading(ShowChoirContests);
const LifeAfterWL = withLoading(LifeAfter);
const CollegeConnectionWL = withLoading(CollegeConnection);
const RecipesWL = withLoading(Recipes);
const CelebritiesWL = withLoading(Celebrities);
const RiseOfShowChoirWL = withLoading(RiseOfShowChoir);

const EchoesOfHarmonyWL = withLoading(EchoesOfHarmony);

const TicTacToeWL = withLoading(TicTacToe);
const HomeWL = withLoading(Home);
const AboutWL = withLoading(About);
const ColoringOptionsWL = withLoading(ColoringOptions);
const ColoringBookWL = withLoading(ColoringBook);
const CrossWordWL = withLoading(CrossWord);
const CrossWordThreeWL = withLoading(CrossWordThree);
const TriviaHomeWL = withLoading(TRiviaHome);
const CrossWordTwoWL = withLoading(CrossWordTwo);
const ExcellenceAndSuccessWL = withLoading(ExcellenceAndSuccess);
const BroadwayWL = withLoading(Broadway);
const ShowdownWL = withLoading(Showdown);
const HeartsWL = withLoading(Hearts);
const MovesWL = withLoading(Moves);
const GamesWL = withLoading(Games);
const ArticlesPageWL = withLoading(ArticlesPage);
const ActivitiesPageWL = withLoading(ActivitiesPage);
const ScavengerHuntWL = withLoading(ScavengerHunt);



function AppContent() {
  const noHeaderFooterPaths = ['/tictactoe', '/trivia', '/crossword', '/crossword2', '/crossword3', '/scavengerhunt']; // Declare before usage
  const location = useLocation(); // valid inside Router context

  function isColoringBookPath(pathname) {
    return pathname.startsWith('/coloringbook');
  }

  const shouldHideHeaderFooter =
    noHeaderFooterPaths.includes(location.pathname) || isColoringBookPath(location.pathname);

  return (
    <div className="App">
      {!shouldHideHeaderFooter && <Header />}
      <main>
        <Routes>
          <Route path="/tictactoe" element={<TicTacToeWL />} />
          <Route path="/" element={<HomeWL />} />
          <Route path="/about" element={<AboutWL />} />
          <Route path="/coloringbookoptions" element={<ColoringOptionsWL />} />
          <Route path="/coloringbook/:id" element={<ColoringBookWL />} />
          <Route path='/trivia' element={<TriviaHomeWL />} />
          <Route path='/crossword' element={<CrossWordWL />} />
          <Route path='/crossword2' element={<CrossWordTwoWL />} />
          <Route path='/crossword3' element={<CrossWordThreeWL />} />
          <Route path='/scavengerhunt' element={<ScavengerHuntWL />} />


          <Route path='/harmonyandhearts' element={<HarmonyAndHeartsWL />} />
          <Route path='/inyourseat' element={<InYourSeatWL />} />
          <Route path='/showchoircontests' element={<ShowChoirContestsWL />} />
          <Route path='/excellenceandsuccess' element={<ExcellenceAndSuccessWL />} />
          <Route path='/broadway' element={<BroadwayWL />} />
          <Route path='showdown' element={<ShowdownWL />} />
          <Route path='/harmonizinghearts' element={<HeartsWL />} />
          <Route path='/harmonizingmoves' element={<MovesWL />} />
          <Route path='/lifeafter' element={<LifeAfterWL />} />
          <Route path='/collegeconnection' element={<CollegeConnectionWL />} />
          <Route path='/outfits' element={<OutfitsWL />} />
          <Route path='/recipes' element={<RecipesWL />} />
          <Route path='/celebrities' element={<CelebritiesWL />} />
          <Route path='/echoesofharmony' element={<EchoesOfHarmonyWL />} />
          <Route path='/riseofshowchoir' element={<RiseOfShowChoirWL />} />

          <Route path='/games' element={<GamesWL />} />
          <Route path='/articlespage' element={<ArticlesPageWL />} />
          <Route path='/activitiespage' element={<ActivitiesPageWL />} />
        </Routes>
      </main>
      {!shouldHideHeaderFooter && <Footer />}
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;